export default __webpack_public_path__ + "static/media/Did-you-know.572a7190.svg";